import React from 'react';
import ReactEcharts from "echarts-for-react"; 
import echarts from 'echarts/lib/echarts';
import { Box, Pagination } from "@mui/material";


// export default function FunnelChart({chartInfo}) {  

//     return (  
//         <ReactEcharts
//             echarts={echarts}
//             option={chartInfo}
//             opts={{renderer: 'svg'}}
//             style={{width: '100%', height: '500px'}}
//         />
//     )
// }


const FunnelChart = ({ chartInfo, pagination }) => {
  return (
    <div>
      <ReactEcharts echarts={echarts} option={chartInfo} style={{ height: '400px', width: '100%' }} />
      {pagination && (
        <Box
          sx={{
            marginTop: "10px",
            display: "flex",
            justifyContent: "right",
            alignItems: "right",
            padding: "5px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
          }}
        >
            {pagination}
         
        </Box>
      )}
    </div>
  );
};

export default FunnelChart;